(function () {
  "use strict";

  function initVSBrands(section) {

    if (!section) {
      return;
    }

    /*
     * Prevent duplicate initialization.
     */
    if (section.dataset.vsBrandsReady === "true") {
      return;
    }

    const grid = section.querySelector(
      "[data-vs-brands-grid]"
    );

    const cards = Array.from(
      section.querySelectorAll(
        "[data-vs-brand-card]"
      )
    );

    const searchInput =
      section.querySelector(
        ".vs-brand-search-input"
      );

    const clearButton =
      section.querySelector(
        "[data-vs-search-clear]"
      );

    const sortSelect =
      section.querySelector(
        ".vs-brand-sort"
      );

    const totalElement =
      section.querySelector(
        "[data-vs-total]"
      );

    const noResults =
      section.querySelector(
        "[data-vs-no-results]"
      );


    /*
     * Grid is required.
     */
    if (!grid) {
      return;
    }


    section.dataset.vsBrandsReady = "true";


    let searchValue = "";

    let sortValue =
      sortSelect
        ? sortSelect.value || "popular"
        : "popular";


    /* =====================================================
       NORMALIZE
    ===================================================== */

    function normalize(value) {

      return String(value || "")
        .normalize("NFKC")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");

    }


    /* =====================================================
       CLEAR SEARCH BUTTON
    ===================================================== */

    function updateClearButton() {

      if (!clearButton) {
        return;
      }

      clearButton.hidden =
        searchValue.length === 0;

    }


    /* =====================================================
       SORT CARDS
    ===================================================== */

    function sortCards(cardList) {

      return cardList.sort(function (a, b) {

        const brandA =
          normalize(
            a.dataset.vsBrand
          );

        const brandB =
          normalize(
            b.dataset.vsBrand
          );

        const countA =
          Number(
            a.dataset.vsCount || 0
          );

        const countB =
          Number(
            b.dataset.vsCount || 0
          );


        /*
         * A-Z
         */
        if (sortValue === "az") {

          return brandA.localeCompare(
            brandB,
            undefined,
            {
              sensitivity: "base"
            }
          );

        }


        /*
         * Z-A
         */
        if (sortValue === "za") {

          return brandB.localeCompare(
            brandA,
            undefined,
            {
              sensitivity: "base"
            }
          );

        }


        /*
         * Popular
         * Highest product count first.
         * If count is same, use A-Z.
         */
        return (
          countB - countA
        ) ||
        brandA.localeCompare(
          brandB,
          undefined,
          {
            sensitivity: "base"
          }
        );

      });

    }


    /* =====================================================
       FILTER + RENDER
    ===================================================== */

    function updateBrands() {

      /*
       * Search ONLY brand/vendor name.
       */
      const visibleCards =
        cards.filter(function (card) {

          const brand =
            normalize(
              card.dataset.vsBrand
            );


          /*
           * Empty search:
           * show every brand.
           */
          if (!searchValue) {
            return true;
          }


          /*
           * Search brand name only.
           */
          return brand.includes(
            searchValue
          );

        });


      /*
       * Apply selected sorting.
       */
      const sortedCards =
        sortCards(
          visibleCards
        );


      /*
       * Hide all cards first.
       */
      cards.forEach(function (card) {

        card.hidden = true;

      });


      /*
       * Show matching cards
       * in sorted order.
       */
      sortedCards.forEach(
        function (card) {

          card.hidden = false;

          grid.appendChild(
            card
          );

        }
      );


      /*
       * Update visible brand count.
       */
      if (totalElement) {

        totalElement.textContent =
          "(" +
          sortedCards.length +
          ")";

      }


      /*
       * Show/hide no-results message.
       */
      if (noResults) {

        noResults.hidden =
          sortedCards.length !== 0;

      }


      /*
       * Update clear button.
       */
      updateClearButton();

    }


    /* =====================================================
       SEARCH
    ===================================================== */

    if (searchInput) {

      searchInput.addEventListener(
        "input",
        function () {

          searchValue =
            normalize(
              searchInput.value
            );

          updateBrands();

        }
      );

    }


    /* =====================================================
       CLEAR SEARCH
    ===================================================== */

    if (clearButton) {

      clearButton.addEventListener(
        "click",
        function () {

          if (!searchInput) {
            return;
          }


          searchInput.value = "";

          searchValue = "";


          updateBrands();


          /*
           * Put cursor back into search.
           */
          searchInput.focus();

        }
      );

    }


    /* =====================================================
       SORT
    ===================================================== */

    if (sortSelect) {

      sortSelect.addEventListener(
        "change",
        function () {

          sortValue =
            sortSelect.value ||
            "popular";

          updateBrands();

        }
      );

    }


    /* =====================================================
       INITIAL RENDER
    ===================================================== */

    updateBrands();

  }


  /* =======================================================
     INITIALIZE ALL BRAND SECTIONS
  ======================================================= */

  function initAllVSBrands() {

    document
      .querySelectorAll(
        ".vs-brands-page"
      )
      .forEach(
        initVSBrands
      );

  }


  /* =======================================================
     DOCUMENT READY
  ======================================================= */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initAllVSBrands
    );

  } else {

    initAllVSBrands();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
     SECTION LOAD
  ======================================================= */

  document.addEventListener(
    "shopify:section:load",
    function (event) {

      const section =
        event.target.matches &&
        event.target.matches(
          ".vs-brands-page"
        )
          ? event.target
          : event.target.querySelector
            ? event.target.querySelector(
                ".vs-brands-page"
              )
            : null;


      if (!section) {
        return;
      }


      /*
       * Section was re-rendered by
       * Shopify Theme Editor.
       *
       * Remove the old initialization
       * flag and initialize again.
       */
      delete section.dataset
        .vsBrandsReady;


      initVSBrands(
        section
      );

    }
  );


  /* =======================================================
     SHOPIFY THEME EDITOR
     SECTION UNLOAD
  ======================================================= */

  document.addEventListener(
    "shopify:section:unload",
    function (event) {

      const section =
        event.target.querySelector
          ? event.target.querySelector(
              ".vs-brands-page"
            )
          : null;


      if (!section) {
        return;
      }


      /*
       * Allow the section to be
       * initialized again if Shopify
       * re-renders it.
       */
      delete section.dataset
        .vsBrandsReady;

    }
  );

})();